import { theme } from '../../styles/theme';
export const accountContainerStyle = (width, height) => ({
    width: width || '50px',
    minWidth: width || '50px',
    height: height || '50px',
    background: '#EEE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    svg: {
        fill: theme.palette.common.white,
        height: calculateInnerSvgHeight(height),
        width: 'auto'
    },
    img: {
        opacity: '1 !important',
        height: calculateInnerSvgHeight(height)
    }
});
export const accountImageStyle = (imageUri, width, height, rectangular, handlePhotoClick) => ({
    overflow: 'hidden',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    img: {
        opacity: 0
    },
    cursor: handlePhotoClick ? 'pointer' : 'unset',
    backgroundImage: `url('${imageUri}')`,
    width,
    height,
    minWidth: width,
    borderRadius: rectangular ? '4px' : '100px'
});
const calculateInnerSvgHeight = (height) => {
    if (height) {
        const heightNumber = +height.split('px')[0];
        return heightNumber * 0.6 + 'px';
    }
    return 'auto';
};
//# sourceMappingURL=AccountPhoto.style.js.map